var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#EDEDED;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#4BC240;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#E0C145;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#C72525;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#E8C743;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#3BA132;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#42B837;}\n\t.st7{fill:none;stroke:#2E324F;stroke-width:5;stroke-miterlimit:10;}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#C7AB3B;}\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:#AD2323;}\n\t.st10{fill:none;stroke:#CF4D52;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#E8C94F;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:#BF97CC;}\n\t.st13{fill:#41B536;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.08,415.23c87.59,0,159.14-71.55,159.14-159.14c0-87.75-71.55-159.31-159.14-159.31 c-87.75,0-159.31,71.56-159.31,159.31C96.77,343.67,168.33,415.23,256.08,415.23L256.08,415.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.12,387.71h58.83c-0.99-3.47-1.49-7.11-1.49-10.91c0-22.31,18.18-40.32,40.48-40.32 c22.31,0,40.33,18.01,40.33,40.32c0,3.8-0.5,7.43-1.49,10.91h58.83V307.4c0-7.93-6.44-14.21-14.21-14.21H168.33 c-7.77,0-14.21,6.28-14.21,14.21V387.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M182.38,292.86h41.98c-0.66-2.32-0.99-4.96-0.99-7.61c0-16.03,13.05-28.92,28.92-28.92 c16.03,0,28.92,12.89,28.92,28.92c0,2.65-0.33,5.29-0.99,7.61h42.14v-57.51c0-5.45-4.63-10.08-10.25-10.08H192.46 c-5.45,0-10.08,4.62-10.08,10.08V292.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M210.8,178.33h84.11c3.8,0,6.78,3.14,6.78,6.94v40h-97.67v-40C204.03,181.47,207.16,178.33,210.8,178.33 L210.8,178.33z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.36,178.33 252.94,124.29 223.36,178.33  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M154.12,387.71h56.02c-0.99-3.31-1.32-6.61-1.32-10.08c0-11.57,5.29-21.81,13.88-28.75 c7.44-7.61,17.68-12.4,29.25-12.4c22.31,0,40.33,18.01,40.33,40.32c0,3.8-0.5,7.43-1.49,10.91h49.41v-74.2 c0-7.27-6.11-13.22-13.55-13.22H167.67c-7.44,0-13.55,5.95-13.55,13.22V387.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M247.32,334.33c9.25,0,17.85,2.81,25.12,7.76c-6.11-3.63-13.05-5.61-20.5-5.61 c-22.31,0-40.48,18.01-40.48,40.32c0,3.8,0.49,7.43,1.49,10.91h-9.42c-0.5-2.81-0.83-5.62-0.83-8.6 C202.7,354.33,222.7,334.33,247.32,334.33L247.32,334.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M154.12,387.71h58.83c-0.99-3.47-1.49-7.11-1.49-10.91c0-22.31,18.18-40.32,40.48-40.32 c22.31,0,40.33,18.01,40.33,40.32c0,3.8-0.5,7.43-1.49,10.91h58.83V307.4c0-7.93-6.44-14.21-14.21-14.21H168.33 c-7.77,0-14.21,6.28-14.21,14.21V387.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M217.74,292.86c0.16-10.58,2.31-19.83,11.07-24.63c5.29-7.27,13.88-11.89,23.47-11.89 c16.03,0,28.92,12.89,28.92,28.92c0,2.65-0.33,5.29-0.99,7.61h32.22v-48.92c0-5.45-4.46-10.08-10.08-10.08H182.71h-0.17 c-0.17,0.5-0.17,0.99-0.17,1.49v57.51H217.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M249.14,254.85c6.61,0,12.72,1.98,17.85,5.45c-4.3-2.64-9.26-3.96-14.71-3.96 c-15.87,0-28.92,12.89-28.92,28.92c0,2.65,0.33,5.29,0.99,7.61h-6.61c-0.5-1.99-0.66-3.97-0.66-6.11 C217.08,269.06,231.46,254.85,249.14,254.85L249.14,254.85z M281.03,289.05c-0.17,1.32-0.33,2.64-0.5,3.8h-0.33 C280.54,291.69,280.87,290.37,281.03,289.05L281.03,289.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M182.38,292.86h41.98c-0.66-2.32-0.99-4.96-0.99-7.61c0-16.03,13.05-28.92,28.92-28.92 c16.03,0,28.92,12.89,28.92,28.92c0,2.65-0.33,5.29-0.99,7.61h42.14v-57.51c0-5.45-4.63-10.08-10.25-10.08H192.46 c-5.45,0-10.08,4.62-10.08,10.08V292.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M209.81,185.93h78.66c3.14,0,5.78,2.65,5.78,5.79v33.55h-90.23v-33.55 C204.03,188.58,206.67,185.93,209.81,185.93L209.81,185.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M210.8,178.33h84.11c3.8,0,6.78,3.14,6.78,6.94v40h-97.67v-40C204.03,181.47,207.16,178.33,210.8,178.33 L210.8,178.33z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "274.59,178.33 248.98,131.23 223.36,178.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "282.36,178.33 252.94,124.29 223.36,178.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "175.6,172.88 178.91,183.12 189.65,183.12 180.89,189.4 184.36,199.65 175.6,193.2 166.84,199.65  170.31,189.4 161.56,183.12 172.3,183.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "370.11,276.49 373.41,286.74 384.16,286.74 375.4,293.02 378.7,303.26 370.11,296.98 361.35,303.26  364.66,293.02 355.9,286.74 366.8,286.74  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M136.93,305.42c5.12,0,9.09-3.97,9.09-9.09c0-4.96-3.97-9.09-9.09-9.09c-4.96,0-9.09,4.13-9.09,9.09 C127.84,301.45,131.97,305.42,136.93,305.42L136.93,305.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M332.6,197.68c-1.38,0-2.5-1.12-2.5-2.5v-19c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5v19 C335.1,196.56,333.98,197.68,332.6,197.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M342.02,188.26h-18.84c-1.38,0-2.5-1.12-2.5-2.5c0-1.38,1.12-2.5,2.5-2.5h18.84c1.38,0,2.5,1.12,2.5,2.5 C344.52,187.15,343.4,188.26,342.02,188.26z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.5bcb8c46eef9bfb3d3e18012ca64740c.svg";
export { ForwardRef as ReactComponent };